// extracted by mini-css-extract-plugin
export default {"richContent":"PffucE","showMoreOrLess":"jxiFxb"};